import type { ReactNode } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import type { DialogProps as MDialogProps } from "@material-ui/core";
import { Dialog as MDialog, DialogContent, DialogActions, Button } from "@material-ui/core";
import type { DialogTitleProps } from "./DialogTitle";
import { DialogTitle } from "./DialogTitle";

export type DialogCloseReason =
    | "backdropClick"
    | "closeButtonClick"
    | "cancelButtonClick"
    | "escapeKeyDown"
    | "formSubmit"
    | "okButtonClick";

export type DialogProps = DialogTitleProps & {
    onClose: (reason: DialogCloseReason) => void;
    open: boolean;
    dialogOptions?: Partial<Omit<MDialogProps, "classes">>;
    children?: ReactNode;
};

export const Dialog = (props: DialogProps) => {
    const { t } = useTranslation();
    const { dialogOptions, onClose, open, subTitle, subTitle2, title, children } = props;

    const handleClose = (reason: DialogCloseReason) => {
        onClose(reason);
    };

    return (
        <MDialog
            open={open}
            maxWidth="xs"
            disableBackdropClick
            disablePortal
            onClose={(_, reason) => handleClose(reason)}
            {...dialogOptions}
        >
            <DialogTitle title={title} subTitle={subTitle} subTitle2={subTitle2} />
            <DialogContent dividers>{children}</DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={() => handleClose("closeButtonClick")}>
                    {t("Gui.Buttons.Close")}
                </Button>
            </DialogActions>
        </MDialog>
    );
};
